import profilePhoto from "../assets/photo.jpeg";

function AboutMe() {
  return (
    <section id="aboutme" className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-6xl mx-auto w-full relative z-10 grid md:grid-cols-2 gap-8 md:gap-16 items-center mb-16">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4 animate-fade-in">
              {/* <div className="inline-block px-4 py-2 bg-green-500/20 border border-green-500/50 rounded-full text-black font-semibold text-sm uppercase tracking-wider">
                ✨ Presidential Candidate 2025
              </div> */}
              <h1 className="text-6xl md:text-7xl lg:text-8xl font-black leading-tight text-black">
                <span className="bg-gradient-to-r from-green-400 via-emerald-300 to-cyan-400 bg-clip-text text-black">
                  Andrew
                </span>
                <br />
                <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-black">
                  Poudel
                </span>
              </h1>
              <div className="space-y-2">
                <p className="text-2xl md:text-3xl font-bold text-black">
                  Director of Grace International Consultancy
                </p>
                <p className="text-xl text-black">Leading ECAN into Tomorrow</p>
              </div>
              <p className="text-black text-lg md:text-xl leading-relaxed max-w-lg">
                Empowering communities, uniting education consultancies, and
                creating global pathways for every Nepali student to achieve
                extraordinary success.
              </p>
            </div>
          </div>
          {/* Right Profile Image */}
          <div className="flex justify-center items-center animate-fade-in-delay-1">
            <div className="relative w-full max-w-sm">
              {/* Animated Glow */}
              <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-emerald-500 rounded-3xl blur-3xl opacity-30 animate-pulse"></div>
              {/* Profile Card with Photo */}
              <div className="relative p-1 shadow-2xl">
                <div className="bg-gradient-to-br from-gray-900 to-black overflow-hidden h-96 md:h-[500px] flex flex-col items-center justify-center space-y-4 relative">
                  <img
                    src={profilePhoto}
                    alt="Andrew Poudel"
                    className="w-[400px] h-full object-cover mb-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Original About Me content below */}
        <div className="grid md:grid-cols-2 gap-12 items-start mb-16">
          <div>
            <h2 className="text-xl font-bold mb-4">My Vision for ECAN</h2>
            <p className="text-gray-700 text-lg">
              A progressive, member-first ECAN that empowers every
              consultancy—big or small—to deliver ethical, high-quality guidance
              and open global opportunities for Nepali students.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-bold mb-4">
              My Promise as Your Next President
            </h2>
            <ul className="list-disc list-inside text-gray-700 text-lg space-y-2">
              <li>Stronger unity and collaboration among members</li>
              <li>
                More training, resources, and digital tools for consultancies
              </li>
              <li>
                Louder, more effective advocacy with government and
                international partners
              </li>
              <li>Transparent leadership that listens and delivers results</li>
            </ul>
          </div>
        </div>
        {/* Who I Am Cards (2 columns, 3 each) */}
        <div className="grid md:grid-cols-2 gap-10">
          <div className="space-y-10">
            {/* Philanthropist */}
            <div className="bg-gray-50 rounded-2xl shadow-lg p-8 space-y-4">
              <h3 className="text-3xl font-bold text-green-600 mb-2">
                Philanthropist
              </h3>
              <p className="italic text-lg text-gray-700">
                I don’t see “help” as charity. I see it as responsibility{" "}
                <span className="font-bold">(जिम्मेवारी)</span>.
              </p>
              <p className="text-gray-700">
                Sometimes it’s supporting a community initiative, sometimes it’s
                standing beside a family during a tough time, and sometimes it’s
                quietly helping someone who doesn’t even ask.
              </p>
              <blockquote className="border-l-4 border-green-400 pl-4 text-green-700 font-semibold">
                If I have the capacity to uplift, then I also have the duty to
                act.
                <br />{" "}
                <span className="font-bold">
                  सक्ने अवस्थामा छु भने, म सक्दो हात बढाउँछु।
                </span>
              </blockquote>
              <p className="text-gray-700">
                For me, philanthropy isn’t a big event or a public announcement.
                It’s a daily mindset ‘बानी’—small acts, consistent support, and
                genuine care.
              </p>
            </div>
            {/* Dream Architect */}
            <div className="bg-gray-50 rounded-2xl shadow-lg p-8 space-y-4">
              <h3 className="text-3xl font-bold text-green-600 mb-2">
                Dream Architect
              </h3>
              <p className="italic text-lg text-gray-700">
                Dreams are easy. Blueprints are rare.
              </p>
              <p className="text-gray-700">
                I meet students every day who carry big dreams—some spoken
                confidently, some hidden quietly because they’re scared of
                failing. And honestly, I relate to that. I’ve also been a
                dreamer. I’ve also had my own moments of doubt, confusion, and
                pressure.
              </p>
              <p className="text-gray-700">
                That’s why I don’t try to “sell motivation.” I try to help
                students (and myself) do something more practical: turn a dream
                into a direction. A plan. A pathway. A next step.
              </p>
              <p className="text-gray-700">
                Because a student’s dream is not just about going abroad or
                getting a degree. It’s about becoming someone, improving their
                family’s future, and proving to themselves that they can rise.
              </p>
              <div className="grid md:grid-cols-3 gap-4 text-center my-4">
                <div className="bg-green-50 rounded-xl p-4">
                  <span className="block text-green-600 font-bold">
                    confusion → clarity
                  </span>
                  <span className="block text-xs text-gray-500">
                    (के गर्ने? कसरी गर्ने?)
                  </span>
                </div>
                <div className="bg-green-50 rounded-xl p-4">
                  <span className="block text-green-600 font-bold">
                    pressure → purpose
                  </span>
                  <span className="block text-xs text-gray-500">
                    (दबाबलाई लक्ष्य बनाउने)
                  </span>
                </div>
                <div className="bg-green-50 rounded-xl p-4">
                  <span className="block text-green-600 font-bold">
                    ambition → action
                  </span>
                  <span className="block text-xs text-gray-500">
                    (सोचलाई काममा बदल्ने)
                  </span>
                </div>
              </div>
              <p className="text-gray-700">
                And in the process, I keep reminding myself too: My dream
                matters only when I help others reach theirs.
              </p>
            </div>
            {/* Mentor • Motivator */}
            <div className="bg-gray-50 rounded-2xl shadow-lg p-8 space-y-4">
              <h3 className="text-3xl font-bold text-green-600 mb-2">
                Mentor • Motivator
              </h3>
              <p className="text-gray-700">
                I don’t see myself as someone “above” others—simply try to be
                useful in people’s journey.
              </p>
              <p className="text-gray-700">
                As a mentor, I don’t only say “तिमी सक्छौ”—I try to show how you
                can do it, step by step. With students, young professionals, and
                teams, my focus is always on clarity, patience, and real-life
                practicality—especially when life feels confusing and decisions
                feel heavy.
              </p>
            </div>
          </div>
          <div className="space-y-10">
            {/* Entrepreneur */}
            <div className="bg-gray-50 rounded-2xl shadow-lg p-8 space-y-4">
              <h3 className="text-3xl font-bold text-green-600 mb-2">
                An Entrepreneur
              </h3>
              <p className="italic text-lg text-gray-700">
                I don’t consider myself someone who “chases trends.” I’m more
                interested in building systems, things that can run, grow, and
                serve people even when I’m not around.
              </p>
              <p className="text-gray-700">
                My journey as an entrepreneur has been shaped by Nepal’s real
                needs. That’s why my work and investments have largely touched
                education and healthcare—two sectors that directly decide the
                quality of people’s lives. I’ve been involved in building
                institutions like colleges and hospitals, not as a status
                symbol, but because I genuinely believe: institutions can create
                long-term impact when they are built with responsibility.
              </p>
              <p className="text-gray-700">
                For me, entrepreneurship is not only about profit. It should
                answer one honest question:
              </p>
              <blockquote className="border-l-4 border-green-400 pl-4 text-green-700 font-semibold">
                “What problem did I solve? and for how many people?”
              </blockquote>
            </div>
            {/* Counselor & ECAN Member */}
            <div className="bg-gray-50 rounded-2xl shadow-lg p-8 space-y-4">
              <h3 className="text-3xl font-bold text-green-600 mb-2">
                Counselor & Proud ECAN Member
              </h3>
              <p className="text-gray-700">
                At the end of the day, I’m proudly a counselor because I know
                education is never just paperwork. It’s emotion. It’s risk. It’s
                a family’s hope. It’s a life decision.
              </p>
              <p className="text-gray-700">
                As the owner of a consultancy, I carry that responsibility every
                single day. And as an active ECAN member, I feel even more
                accountable because ECAN represents the credibility of our
                entire sector.
              </p>
            </div>
            {/* Educationist with a Mission */}
            <div className="bg-gray-50 rounded-2xl shadow-lg p-8 space-y-4">
              <h3 className="text-3xl font-bold text-green-600 mb-2">
                Above All: An Educationist with a Mission
              </h3>
              <p className="text-gray-700">
                Some people build businesses. Some people build brands. I try to
                build futures.
              </p>
              <p className="text-gray-700">
                At the center of everything I do—every project, every
                partnership, every long day that becomes a late night—one simple
                belief: Education should not just change grades. It should
                change destiny.
              </p>
              <p className="text-gray-700">
                I don’t claim to have all the answers. I’m still learning every
                day. But I do know this: when someone trusts you with their
                dream, you must treat it with care, honesty, and responsibility.
              </p>
              <blockquote className="border-l-4 border-green-400 pl-4 text-green-700 font-semibold">
                If I have a role I value the most, it’s this: I’m a counselor
                who listens first, and an educationist on a mission to help
                people move forward.
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutMe;
